import { QALITY_TEST_ISSUE_TYPE } from '@qality/common-config/src/constants';
import { IssueRequiredField } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

import JiraAPIConstants from './JiraAPIConstants';

export default {
  /** Deprecated since Jira 8.4.0 */
  async getQAlityIssueTypeFields(
    projectKey: string
  ): Promise<Array<IssueRequiredField>> {
    const query = `?projectKeys=${projectKey}&issuetypeNames=${QALITY_TEST_ISSUE_TYPE}&expand=projects.issuetypes.fields`;
    const projectsResponse = await StorageOfUniqueServices.get('API')
      .request({
        url: JiraAPIConstants.URL_GET_CREATE_ISSUE_METADATA + query,
        type: 'GET',
        contentType: 'application/json',
      })
      .then((response) => {
        return JSON.parse(response.body);
      });

    const [firstProject] = projectsResponse.projects;
    const [QAlityIssueType] = firstProject.issuetypes;

    if (!QAlityIssueType) {
      return [];
    }

    const {
      fields: QalityIssueTypeFields,
    }: { fields: Array<IssueRequiredField> } = QAlityIssueType;
    const QalityIssueTypeFieldsArray = Object.entries(
      QalityIssueTypeFields
    ).map(([key, value]) => ({
      // eslint-disable-next-line @typescript-eslint/ban-types
      ...value,
      key,
    }));

    return QalityIssueTypeFieldsArray;
  },
};
